<app-banner></app-banner>
<app-why-platform></app-why-platform>
<app-how-it-works></app-how-it-works>
<app-secure-flow></app-secure-flow>
<app-benchmark-library></app-benchmark-library>
<app-audience></app-audience>
<app-about-tanuh></app-about-tanuh>
<app-faq></app-faq>
<app-cta-banner></app-cta-banner>
<app-footer></app-footer>
